'use client'

import AppInit from '@/components/app-init'
import { Header } from '@/components/header'
import ClientOnlyErrorBoundary from '@/components/ClientOnlyErrorBoundary'
import { Providers } from '@/components/providers'
import { TailwindIndicator } from '@/components/tailwind-indicator'
import { Toaster } from '@/components/ui/sonner'
import ConditionalNavigationGuardProvider from '@/lib/hooks/conditional-navigation-provider'
import Onboarding from '@/components/onboarding/instructions'
import { SidebarProvider } from '@/lib/hooks/use-sidebar'
import { NotificationPreviewProvider } from '@/components/notifications/notification-preview-provider'

export function AuthenticatedLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <AppInit />
      <Toaster position="top-center" />
      <Providers attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <ConditionalNavigationGuardProvider>
          <SidebarProvider defaultOpen={false}>
            <div className="flex min-h-dvh w-full bg-muted/50">
              <div className="flex w-full flex-col">
                {/* <Header className="fixed left-0 right-0 top-0 safe-top z-50 bg-background/80 backdrop-blur-sm" /> */}
                <main className="flex-1">
                  <div className="h-dvh overflow-y-auto">
                    <div className="h-full">
                      <ClientOnlyErrorBoundary>
                        <Onboarding />
                        {children}
                      </ClientOnlyErrorBoundary>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </SidebarProvider>
        </ConditionalNavigationGuardProvider>
        <TailwindIndicator />
      </Providers>
      <NotificationPreviewProvider />
    </>
  )
} 
